function n(o){return o.error==="not-found"}export{n as isError};
